import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DocumentForm from './DocumentForm.jsx'
//import _ from 'lodash'

class AddDocumentComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.document.document) {
      return <div><DocumentForm document={this.props.document}></DocumentForm></div>
    }
    return <div></div>
  }
}

AddDocumentComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  document: PropTypes.object.isRequired,
}

export default AddDocumentComponent
